import {
  localNerisStatusReverseMatching,
  statusReverseMatching,
} from '../../../pages/Incidents/utils/statusMatching';

export const FILTER_PARAMS = {
  from_date: 'fromDate',
  to_date: 'toDate',
  type: 'type',
  status: 'status',
  local_neris_status: 'form_status',
  neris_status: 'nerisStatus',
  response_time: 'responseTime',
  department: 'department',
  employee: 'employee',
};

/**
 Filters configuration for URL <-> state <-> API mapping.

 Types:
 "range": date range using two URL keys. State: { fromDate, toDate } or {}.
 "multi": multiple values joined by comma in URL. State: string[].
 "single": single value in URL. State: [string] or [].

 Fields:
 type: "range" | "multi" | "single"
 key?: string // URL key for "single"/"multi"
 keys?: [string, string] // URL keys for "range" as [fromKey, toKey]
 mapApi?: (value: string) => any // optional transformer before sending to API
 }; */
export const SCHEMA = {
  dateRange: {
    type: 'range',
    keys: [FILTER_PARAMS.from_date, FILTER_PARAMS.to_date],
  },
  [FILTER_PARAMS.type]: { type: 'multi', key: FILTER_PARAMS.type },
  [FILTER_PARAMS.status]: {
    type: 'single',
    key: FILTER_PARAMS.status,
    mapApi: (v) => String(v).toLowerCase(),
  },
  [FILTER_PARAMS.neris_status]: {
    type: 'single',
    key: FILTER_PARAMS.neris_status,
    mapApi: (v) => statusReverseMatching(v),
  },
  [FILTER_PARAMS.local_neris_status]: {
    type: 'single',
    key: FILTER_PARAMS.local_neris_status,
    mapApi: (v) => localNerisStatusReverseMatching(v),
  },
  [FILTER_PARAMS.response_time]: {
    type: 'single',
    key: FILTER_PARAMS.response_time,
    mapApi: (v) => RESPONSE_TIME_CONFIG[v],
  },
  [FILTER_PARAMS.department]: { type: 'single', key: FILTER_PARAMS.department },
  [FILTER_PARAMS.employee]: { type: 'multi', key: FILTER_PARAMS.employee },
};

const RESPONSE_TIME_CONFIG = {
  '<5 Min': { trt_sign: '<', trt_value: '300' },
  '10+ Min': { trt_sign: '>', trt_value: '600' },
  '5-10 Min': { trt_sign: 'between', trt_value: '300|600' },
};

export const initSettings = Object.keys(SCHEMA).reduce((acc, k) => {
  acc[k] = SCHEMA[k].type === 'range' ? {} : [];
  return acc;
}, {});
